import { useMediaQuery } from 'react-responsive'

export const useResponsiveness = () => {
  return {
    isDesktop: useMediaQuery({ query: '(min-width: 1050px)' }),
    isMobileLandscape: useMediaQuery({ query: '(min-width: 568px)' }),
  }
}
